module.exports = __webpack_public_path__ + "img/client_efteling.ff20cff2.png";